const features = [
  {
    icon: 'ri-tools-line',
    title: 'Serviço Técnico Oficial',
    desc: 'Reparos e manutenções com peças originais de fábrica.',
  },
  {
    icon: 'ri-global-line',
    title: 'Distribuição Internacional',
    desc: 'Atendemos Brasil e Argentina com entrega rápida.',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Garantia de Qualidade',
    desc: 'Equipamentos importados com certificação e procedência garantida.',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: 'Suporte Dedicado',
    desc: 'Nossa equipe responde via WhatsApp com agilidade.',
  },
];

export default function AboutSection() {
  return (
    <section id="sobre" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div className="relative">
            <div className="grid grid-cols-2 gap-3">
              <div className="w-full h-64 rounded-2xl overflow-hidden">
                <img
                  alt="Estoque de máquinas de solda geomembrana"
                  className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-700"
                  src="https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=768,h=487,fit=crop/A0xVvobDbRIBrVE7/muchas-rojas-con-cajas-A8543EvBNjfW0ORg.jpg"
                />
              </div>
              <div className="w-full h-64 rounded-2xl overflow-hidden mt-8">
                <img
                  alt="Soldadoras para geomembrana disponíveis"
                  className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-700"
                  src="https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=768,h=486,fit=crop/A0xVvobDbRIBrVE7/muchas-soldadoras-rojas-mxB7kMa8jKhoPalp.jpg"
                />
              </div>
            </div>
            <div className="absolute -bottom-4 left-1/2 -translate-x-1/2 bg-green-500 text-white text-sm px-6 py-3 rounded-full whitespace-nowrap">
              +10 anos de experiência
            </div>
          </div>

          <div>
            <span className="text-green-500 text-xs uppercase tracking-widest mb-3 block">Sobre Nós</span>
            <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black text-gray-900 mb-5 leading-none uppercase">
              ESPECIALISTAS<br />
              <span className="text-green-500">EM GEOMEMBRANA</span>
            </h2>
            <p className="text-gray-500 text-sm leading-relaxed mb-4">
              A <strong className="text-gray-900 font-black">SoldaGeo</strong> tem mais de{' '}
              <strong className="text-gray-900 font-black">10 anos no mercado</strong>, sediada em Florianópolis
              (SC, Brasil) e com operação na Argentina. Somos importadores e distribuidores oficiais de{' '}
              <strong className="text-gray-900 font-black">máquinas de solda geomembrana</strong> — cunha quente,
              extrusoras e acessórios para impermeabilização profissional.
            </p>
            <p className="text-gray-500 text-sm leading-relaxed mb-8">
              Nossos equipamentos atendem projetos de{' '}
              <strong className="text-gray-900 font-black">
                aterros sanitários, reservatórios, barragens, canais de irrigação e mineração
              </strong>{' '}
              em toda a América do Sul — com suporte técnico especializado e peças originais de fábrica.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {features.map((f) => (
                <div key={f.title} className="flex items-start gap-3 p-4 rounded-xl bg-gray-50 border border-gray-100">
                  <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-green-100 flex-shrink-0">
                    <i className={`${f.icon} text-green-600`} />
                  </div>
                  <div>
                    <h4 className="text-gray-900 font-black text-sm mb-0.5 uppercase">{f.title}</h4>
                    <p className="text-gray-500 text-xs leading-relaxed">{f.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
